import { AssistantStreamEvent } from "../../entities/company/Assistant/AssistantChat";

/**
 * Parsea un buffer de Server-Sent Events (`data: {json}\n\n`).
 * Devuelve los eventos completos y el resto incompleto para concatenar con el próximo chunk.
 */
export function parseSseBuffer(buffer: string): {
  events: AssistantStreamEvent[];
  rest: string;
} {
  const normalized = buffer.replace(/\r\n/g, "\n");
  const parts = normalized.split("\n\n");
  const rest = parts.pop() ?? "";
  const events: AssistantStreamEvent[] = [];

  for (const part of parts) {
    const data = part
      .split("\n")
      .filter((line) => line.startsWith("data:"))
      .map((line) => line.slice(5).trim())
      .join("");
    if (!data) {
      continue;
    }
    try {
      const event = JSON.parse(data);
      if (event && typeof event.type === "string") {
        events.push(event as AssistantStreamEvent);
      }
    } catch {
      // Evento malformado: se ignora y se sigue con el resto del stream.
    }
  }

  return { events, rest };
}
